/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface TenantContactEvent
 */
export interface TenantContactEvent {
    /**
     * 
     * @type {number}
     * @memberof TenantContactEvent
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof TenantContactEvent
     */
    name?: string;
}

/**
 * Check if a given object implements the TenantContactEvent interface.
 */
export function instanceOfTenantContactEvent(value: object): boolean {
    return true;
}

export function TenantContactEventFromJSON(json: any): TenantContactEvent {
    return TenantContactEventFromJSONTyped(json, false);
}

export function TenantContactEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantContactEvent {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function TenantContactEventToJSON(value?: TenantContactEvent | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

